import { delay } from '@xylabs/sdk-js'

import { OfferValue, PaymentInfoData, RebillyTokenData } from '../models'
import { InfoWrapper } from './InfoWrapper'

export class PaymentInfoWrapper extends InfoWrapper<PaymentInfoData> {
  constructor(value?: PaymentInfoData) {
    super('paymentInfo', value, false)
  }

  public cvc?: string

  public get hasPayFrameData() {
    return this.data.payFrameData && this.data.payFrameData.id
  }

  public setPayFrameData(data?: RebillyTokenData) {
    this.data.payFrameData = data
    this.save()
    return this
  }

  public setCreditCard(value: string) {
    this.data.creditcard = value
    this.save()
    return this
  }

  public setCreditCardValid(value: boolean) {
    this.data.creditcardValid = value
    this.save()
    return this
  }

  public validateCreditCard() {
    if (this.data.creditcardValid === false) {
      return Error('Invalid credit card information')
    }
  }

  public setTermsAccepted(value: boolean) {
    this.data.termsAccepted = value
    this.save()
    return this
  }

  public validateTermsAccepted() {
    if (this.data.termsAccepted !== true) {
      return Error('Please accept the terms')
    }
  }

  public setExpiry(value: string) {
    this.data.expiry = value
    this.save()
    return this
  }

  public setToken(value?: string) {
    this.data.token = value
    this.save()
    return this
  }

  public setPaymentInstrument (paymentInstrument: PaymentInfoData['paymentInstrument']) {
    this.data.paymentInstrument = paymentInstrument
    this.save()
    return this
  }

  public validateExpiry() {
    if ((this.data.expiry?.length ?? 0) === 0) {
      return Error('Expire date may not be empty')
    }
  }

  public setOffer(value: OfferValue) {
    this.data.offer = value
    this.save()
    return this
  }

  public validateOffer() {
    if (this.data.offer === undefined) {
      return Error('Invalid offer selected')
    }
  }

  public setCvc(value: string) {
    this.cvc = value
    this.data.cvc = value
    return this
  }

  public validateCvc() {
    if ((this.cvc?.length ?? 0) === 0) {
      return Error('CVV/CVC may not be empty')
    }
  }

  public async errors() {
    await delay(0)
    if (!this.hasPayFrameData) {
      return [this.validateCreditCard(), this.validateCvc(), this.validateExpiry(), this.validateTermsAccepted()].filter(
        (error) => error !== undefined,
      ) as Error[]
    } else {
      return []
    }
  }
}
